module.exports = __webpack_public_path__ + "static/media/presentation-chart-line.60a8a976.svg";